import { TDistributionData, TWheatColorByCode } from 'types/models/DataAnalysis'
import { FALLBACK_COLOR } from '../../utils/wheatCodeColors'

export const toDistributionChartData = (
  arr: TDistributionData[],
  mode: 'count' | 'percentage',
  colorByCode?: TWheatColorByCode
): {
  rows: any[]
  series: { key: string; name: string; color: string }[]
} => {
  if (!Array.isArray(arr)) return { rows: [], series: [] }

  const wheatCodes = new Set<string>()
  arr.forEach((bin) => {
    bin.segments.forEach((seg) => wheatCodes.add(seg.wheat_code))
  })

  const series = Array.from(wheatCodes).map((code) => ({
    key: code,
    name: `Wheat ${code}`,
    color: colorByCode?.[code] ?? FALLBACK_COLOR,
  }))

  const rows = arr.map((bin) => {
    const row: Record<string, any> = {
      binLabel: bin.bin_name,
      total: 0,
    }
    bin.segments.forEach((seg) => {
      const val =
        mode === 'percentage'
          ? seg.volume_percentage
          : Math.round(
              (seg.volume_percentage / 100) * bin.attributes[0]?.avg
            ) || 0
      row[seg.wheat_code] = val
      row.total += val
    })
    return row
  })

  return { rows, series }
}
